const QUERY_KEYS = {
  INITIALIZE: 'initialize-app',
  USER_DETAILS: 'who-am-i',
  TRANSLATIONS: 'translations',
  FEATURE_FLAGS: 'feature-flags',
  COOKIES: 'cookies',
  TEAMS: {
    LIST: 'team-list',
    GET: 'current-team',
    SUBTEAMS: 'sub-teams',
  },
  AUTH: {
    LOGIN: 'auth-login',
    SOCIAL: 'auth-social',
    AD_STUDIO: 'auth-adstudio',
    AI_CHAT: 'auth-aichat',
  },
  REPORTS: {
    LIST: 'report-list',
  },
  INSIGHTS: {
    LIST: 'insights-list',
    EVENTS: 'insights-events',
    MUTATE_EVENT: 'insights-mutate-event',
  },
  ACTIVITY_CENTER: {
    ACTIVITIES: 'public-activities',
    PROPOSALS_AND_ORDERS: 'proposals-and-orders',
    INVOICES: 'invoices',
  },
  INTEGRATIONS: {
    ADAPTERS: 'adapters-list',
    INTEGRATIONS: 'integrations-list',
  },
  MEDIA_LIBRARY: {
    FILES: 'media-library-files',
    FOLDERS: 'media-library-folders',
    ASSET: 'media-library-asset',
    POST_ASSETS: 'media-library-post-assets',
  },
  DATA_EXPLORER: {
    FIELDS: 'data-explorer-fields',
    DATA: 'data-explorer-data',
  },
  CAMPAIGNS: {
    LIST: 'campaigns-list',
    GET: 'campaign',
    POST_SETS: 'campaign-post-sets',
    POST_SET: 'post-set',
    ALL_POST_SETS: 'all-post-sets',
    POST_SET_POSTS: 'post-set-posts',
    PUBLISH_INITIALIZE: 'publish-initialize',
    PUBLISH_STATUS: 'publish-status',
    SHARES: 'campaign-shares',
    POST_SET_SHARES: 'post-set-shares',
    INSIGHTS_REQUEST: 'campaign-insights-request',
    INSIGHTS: 'campaign-insights-data',
    POST_INSIGHTS_REQUEST: 'campaign-post-insights-request',
    POST_INSIGHTS: 'campaign-post-insights-data',
    ORGANIC_INSIGHTS_REQUEST: 'organic-post-insights-request',
    ORGANIC_INSIGHTS: 'organic-post-insights-data',
    AD_STATUSES: 'campaign-ad-statuses',
    PUBLISHED_POSTS: 'published-posts',
    CAMPAIGN_PLAN_POST_SETS: 'campaign-plan-post-sets',
  },
} as const

export {
  QUERY_KEYS,
}
